export function stickyHeader() {
    var header = document.querySelector('header');
    var setSticky = function () {
        if (window.scrollY > 100) {
            header.classList.add('is-style-sticky');
        }
        else {
            header.classList.remove('is-style-sticky');
        }
    };
    if (header) {
        setSticky();
        window.addEventListener('scroll', setSticky);
    }
}
